export default __webpack_public_path__ + "static/media/Disconnected.9416cbdf.svg";